// src/components/features/Navigacia/tour/sections/naucneVidea.js
import { i18n } from "@/i18n";
import { steps as zapisySteps, branch as zapisyBranch } from "./ciselneZapisy";
import {
  steps as classroomSteps,
  branch as classroomBranch,
} from "./mojaUcebna";

const translate = (...args) => i18n.global.t(...args);
export function steps() {
  const sel = {
    heading: "[data-tour='naucne-heading']",
    subscription: "[data-tour='cta-subscription']",
    freePreview: "[data-tour='cta-free']",
    video: "[data-tour='lesson-video'], video[controls]",
    markComplete: "[data-tour='mark-complete']",
    lyricsToggle: "[data-tour='lyrics-toggle']",
    onlineDifficulty: "[data-tour='mojekurzy-difficulty']",
    onlineSongsHeading: "[data-tour='mojekurzy-songs-heading']",
  };

  const t = translate;

  return [
    // LIST videí
    {
      goto: "/naucne-videa",
      selector: sel.heading,
      title: t("tour.sections.naucneVidea.steps.list.title"),
      text: t("tour.sections.naucneVidea.steps.list.text"),
      side: "left",
      pad: 24,
      radius: 26,
    },
    {
      selector: sel.subscription,
      title: t("tour.sections.naucneVidea.steps.subscription.title"),
      text: t("tour.sections.naucneVidea.steps.subscription.text"),
      side: "top",
      pad: { x: 22, y: 18 },
      radius: 18,
    },
    {
      selector: sel.freePreview,
      title: t("tour.sections.naucneVidea.steps.freePreview.title"),
      text: t("tour.sections.naucneVidea.steps.freePreview.text"),
      side: "top",
      pad: { x: 22, y: 18 },
      radius: 18,
    },

    // DETAIL videa (zadarmo)
    {
      goto: "/ucebna/zadarmo-video",
      selector: sel.video,
      waitFor: 800, // nech sa DOM dotiahne
      closest: "video, .lesson-video, .plyr__video-wrapper, .video-wrapper",
      title: t("tour.sections.naucneVidea.steps.previewVideo.title"),
      text: t("tour.sections.naucneVidea.steps.previewVideo.text"),
      side: "left",
      pad: 24,
      radius: 26,
    },

    // === OZNAČIŤ AKO ZVLÁDNUTÉ ===
    {
      goto: "/ucebna/zadarmo-video",
      selector: sel.markComplete,
      waitFor: 400,
      bind: {
        text: t("lessons.freeLesson.buttons.markComplete"),
      }, // (nájde to aj stav „Zvládnuté“ cez aria-label)
      closest: ".button, [data-tour='mark-complete']",
      title: t("tour.sections.naucneVidea.steps.markComplete.title"),
      text: t("tour.sections.naucneVidea.steps.markComplete.text"),
      side: "top",
      pad: { x: 22, y: 18 },
      radius: 18,
    },

    // === TEXT PIESNE ===
    {
      goto: "/ucebna/zadarmo-video",
      selector: sel.lyricsToggle,
      waitFor: 800, // nech sa dotiahne DOM
      // vyhľadá podľa textu na [role="button"] a [aria-label]
      bind: { text: t("lessons.freeLesson.buttons.showLyrics") },
      // ring nasadíme na celý box
      closest: ".button, [data-tour='lyrics-toggle']",
      title: t("tour.sections.naucneVidea.steps.lyrics.title"),
      text: t("tour.sections.naucneVidea.steps.lyrics.text"),
      side: "top",
      pad: { x: 22, y: 18 },
      radius: 18,
    },

    // MENU
    {
      bind: {
        where: "menu",
        text: t("menu.onlineVyucba"),
        hrefLike: "moje-kurzy",
      },
      title: t("tour.sections.naucneVidea.steps.menu.title"),
      text: t("tour.sections.naucneVidea.steps.menu.text"),
      side: "left",
      pad: 18,
    },
    {
      goto: "/ucebna/moje-kurzy",
      selector: ".box-item.oblubene.narocnost .box-kurz .button",
      waitFor: 600,
      title: t("tour.sections.naucneVidea.steps.difficulty.title"),
      text: t("tour.sections.naucneVidea.steps.difficulty.text"),
      side: "left",
      pad: { x: 14, y: 10 },
      radius: 14,
      scrollMode: "nearest",
      scrollInline: "nearest",
      scrollBehavior: "smooth",
    },
    {
      selector: sel.onlineSongsHeading,
      title: t("tour.sections.naucneVidea.steps.courseSongs.title"),
      text: t("tour.sections.naucneVidea.steps.courseSongs.text"),
      side: "top",
      pad: { x: 22, y: 18 },
      radius: 14,
      scrollMode: "nearest",
      scrollInline: "nearest",
    },
  ];
}

export function branch(ctx = {}) {
  const hasCompleted =
    typeof ctx.hasCompleted === "function" ? ctx.hasCompleted : () => false;
  const hasCompletedAny =
    typeof ctx.hasCompletedAny === "function"
      ? ctx.hasCompletedAny
      : (...keys) => {
          const list = [];
          keys.forEach((key) => {
            if (Array.isArray(key)) list.push(...key);
            else if (key != null) list.push(key);
          });
          return list.some((key) => hasCompleted(key));
        };
  const zapisyDone = hasCompletedAny(["zapisy", "ciselne-zapisy"]);
  const classroomDone = hasCompletedAny(["ucebna", "moja-ucebna"]);

  const options = [];
  const t = translate;
  let text = t("tour.branches.naucneVidea.defaultText");
  let planBridgeLabel = t(
    "tour.branches.naucneVidea.options.scores.planBridgeLabel"
  );

  if (!zapisyDone) {
    options.push({
      label: t("tour.branches.naucneVidea.options.scores.label"),
      goto: "/ciselne-zapisy",
      key: "zapisy",
      name: "zapisy",
      planLabel: t("tour.branches.naucneVidea.options.scores.planLabel"),
      steps: zapisySteps,
      branch: zapisyBranch,
      planBridgeLabel: t(
        "tour.branches.naucneVidea.options.scores.planBridgeLabel"
      ),
    });
    text = t("tour.branches.naucneVidea.scoresText");
  } else if (!classroomDone) {
    options.push({
      label: t("tour.branches.naucneVidea.options.classroom.label"),
      goto: "/ucebna",
      key: "ucebna",
      name: "ucebna",
      planLabel: t("tour.branches.naucneVidea.options.classroom.planLabel"),
      steps: classroomSteps,
      branch: classroomBranch,
      planBridgeLabel: t(
        "tour.branches.naucneVidea.options.classroom.planBridgeLabel"
      ),
    });
    text = t("tour.branches.naucneVidea.classroomText");
    planBridgeLabel = t(
      "tour.branches.naucneVidea.options.classroom.planBridgeLabel"
    );
  } else {
    options.push({
      label: t("tour.branches.naucneVidea.options.finish.label"),
      planLabel: t("tour.branches.naucneVidea.options.finish.planLabel"),
      planBridgeLabel: t(
        "tour.branches.naucneVidea.options.finish.planBridgeLabel"
      ),
      steps: [],
    });
    text = t("tour.branches.naucneVidea.doneText");
    planBridgeLabel = t(
      "tour.branches.naucneVidea.options.finish.planBridgeLabel"
    );
  }

  return {
    title: t("tour.branches.naucneVidea.title"),
    text,
    planBridgeLabel,
    options,
  };
}
